import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { InsertPhoto } from '@material-ui/icons';
import cx from 'classnames';
import { motion, AnimatePresence } from "framer-motion";
import Loader from '../../Loader/Loader';
import { NODES } from '../../../constants';
import { EventEmitter } from '../../../utils';
import PopupWrapper from '../../PopupWrapper';
import axiosUI from '../../../axiosUI';

class Image extends Component {
  static propTypes = {
    editor: PropTypes.object,
    value: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = {
      showPopup: false,
      src: '',
      alt: '',
      imageLoading: false,
    };

    this.togglePopup = this.togglePopup.bind(this);
    this.insertImage = this.insertImage.bind(this);
    this.onChangeHandler = this.onChangeHandler.bind(this);
  }

  componentDidMount() {
    EventEmitter.listen('open-popup--image', () => {
      this.togglePopup();
    });
  }

  togglePopup() {
    this.setState(prevState => ({ showPopup: !prevState.showPopup }));
  }

  insertImage(event) {
    event.preventDefault();

    this.props.editor.insertBlock({
      type: NODES.IMAGE,
      data: { src: this.state.src, alt: this.state.alt },
    });
    this.togglePopup();
    this.setState({ src: '', alt: '' });
  }

  loadImage(file) {
    const reader = new FileReader();
    reader.addEventListener('load', () =>
      this.setState({ src: reader.result })
    );
    reader.addEventListener('loadstart', () => {
      this.setState({ imageLoading: true });
    });
    reader.addEventListener('loadend', () => {
      this.setState({ imageLoading: false });
    });
    reader.readAsDataURL(file);
  }

  onChangeHandler(event) {
    const {
      target: { name, value, files },
    } = event;

    if (name !== 'file') {
      this.setState({ [name]: value });
    } else {
      this.loadImage(files[0]);
    }
  }

  render() {
    const disableSubmitButton = !this.state.src.trim();
    return (
      <PopupWrapper
        isOpen={this.state.showPopup}
        togglePopup={this.togglePopup}>
        <span className="icon__wrapper icon__wrapper--image">
          <button
            title="Image"
            className={cx('icon__button', {
              active: this.state.showPopup,
            })}
            onClick={this.togglePopup}>
            <InsertPhoto />
          </button>
          <AnimatePresence>
            {this.state.showPopup &&
            <motion.div
              initial={{ opacity: 0, y: '80%' }}
              animate={{ opacity: 1, y: '100%' }}
              exit={{ opacity: 0, y: '80%' }}
              transition={{ ease: [0.18, 0.89, 0.39, 1.4], duration: .3 }}
              className="icon__popup icon__popup--image">
              <Loader loading={this.state.imageLoading}>
                <div className="flex items-center justify-between mb-5 w-32">
                  <div className="inline-block overflow-hidden relative">
                    <button className="font-bold normal-button p-1 rounded">
                      Upload Image
                    </button>
                    <input
                      className="absolute cursor-pointer"
                      id="file"
                      name="file"
                      type="file"
                      accept="image/x-png,image/gif,image/jpeg"
                      onChange={this.onChangeHandler}
                    />
                  </div>
                  <span className="text-sm font-bold">or</span>
                </div>
                <label
                  className="flex font-bold justify-between items-center mb-5 text-sm"
                  htmlFor="src">
                  URL*
                  <input
                    className="normal-border-sm w-64 rounded-sm ml-5 p-1"
                    id="src"
                    name="src"
                    type="text"
                    placeholder="image url"
                    onChange={this.onChangeHandler}
                    value={this.state.src}
                  />
                </label>
                <label
                  className="flex font-bold justify-between items-center mb-5 text-sm"
                  htmlFor="alt">
                  Alt
                  <input
                    autoFocus={this.state.src.trim()}
                    className="normal-border-sm w-64 rounded-sm ml-5 p-1"
                    id="alt"
                    name="alt"
                    type="text"
                    placeholder="image description (recommended)"
                    onChange={this.onChangeHandler}
                    value={this.state.alt}
                  />
                </label>
                <button
                  onClick={this.insertImage}
                  className={cx(
                    'cursor-pointer font-bold normal-button p-1 rounded w-full',
                    { disable: disableSubmitButton }
                  )}>
                  Add Image
                </button>
              </Loader>
            </motion.div>}
          </AnimatePresence>
        </span>
      </PopupWrapper>
    );
  }
}

export default  Image;
